import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  Card,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { occupancyData } from "./chart-mock-data";
import SectionTitle from "../section-title";

export function OccupancyChart() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 4,
        height: { xs: 340, sm: 480 },
      }}
    >
      <SectionTitle title="Owner disribution" />

      <Typography
        variant="caption"
        color="success.main"
        sx={{ fontSize: { xs: 11, sm: 12 } }}
      >
        +5% vs last year
      </Typography>

      <Box height={{ xs: 240, sm: 380 }} mt={2}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={occupancyData}
            barSize={isMobile ? 18 : 28}
          >
            <XAxis
              dataKey="month"
              tick={{ fontSize: isMobile ? 10 : 12 }}
              axisLine={false}
              tickLine={false}
            />

            {!isMobile && (
              <YAxis
                unit="%"
                tick={{ fontSize: 12 }}
                axisLine={false}
                tickLine={false}
              />
            )}

            <Tooltip
              formatter={(value) => `${value}%`}
              contentStyle={{
                fontSize: isMobile ? 11 : 12,
                borderRadius: 8,
              }}
            />

            <Bar
              dataKey="occupancy"
              fill="#18aa5aff"
              radius={isMobile ? [3, 3, 0, 0] : [4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
}
